import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.dragSrcEl = null
    this.items = Array.from(this.element.querySelectorAll('[data-id]'))
    this.items.forEach(el => this.attachDnD(el))
  }

  attachDnD(el) {
    el.setAttribute('draggable', 'true')

    el.addEventListener('dragstart', (e) => {
      this.dragSrcEl = el
      e.dataTransfer.effectAllowed = 'move'
      e.dataTransfer.setData('text/plain', el.dataset.id)
      el.classList.add('opacity-60')
    })

    el.addEventListener('dragend', () => {
      el.classList.remove('opacity-60')
    })

    el.addEventListener('dragover', (e) => {
      e.preventDefault()
      e.dataTransfer.dropEffect = 'move'
    })

    el.addEventListener('drop', (e) => {
      e.preventDefault()
      const draggedId = e.dataTransfer.getData('text/plain')
      const draggedEl = this.element.querySelector(`[data-id="${draggedId}"]`)
      const targetEl  = el

      if (!draggedEl || draggedEl === targetEl) return

      // Insert before or after based on vertical position
      const rect = targetEl.getBoundingClientRect()
      const midpoint = rect.top + rect.height / 2
      if (e.clientY < midpoint) {
        targetEl.parentNode.insertBefore(draggedEl, targetEl)
      } else {
        targetEl.parentNode.insertBefore(draggedEl, targetEl.nextSibling)
      }

      this.saveOrder()
    })
  }

  saveOrder() {
    const ids = Array.from(this.element.querySelectorAll('[data-id]')).map(el => el.dataset.id)
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': token,
        'Accept': 'application/json'
      },
      body: JSON.stringify({ order: ids })
    }).then(() => {
      // no-op; could add toast/indicator if desired
    }).catch(() => {
      // no-op
    })
  }
}
